// This is the entry point for all components, index.html will render this component first and other components will be rendered in this component's router outlet.

import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {  }
